//redux提供combineReducers 可以把小的reducer合并成大的reducer
import { combineReducers } from "redux-immutable";

//redux-immutable

//引入小的reducer
import { reducer as headerData } from "../common/Header/store"
import { reducer as RouterReducer } from "../common/Router/store";
import { reducer as userReducer } from "../common/User/store";
import { reducer as activityReducer } from "../common/VoteActivity/store";
import { reducer as videoPlayReducer } from "../components/VideoPlayer/store";
import { reducer as SerchReducer } from "../common/Main/store";

const reducer = combineReducers({
    header: headerData,
    router: RouterReducer,
    user: userReducer,
    activity: activityReducer,
    serch:SerchReducer,
    videoPlay:videoPlayReducer
})

export default reducer
